module.exports = __webpack_public_path__ + "static/media/urbex.872f7f65.svg";